import type { AggsOption } from '@wconcept/wconcept-common/models/display/search';
import Box from '@wconcept/wconcept-ui-renewal/components/atoms/Box';
import FltChkItem from '@wconcept/wconcept-ui-renewal/components/molecules/_item/FltChkItem';
import FltBenefitBox from '@wconcept/wconcept-ui-renewal/components/organisms/_list/FltBenefitBox';
import type { LpProductGroupType } from '@apis/renewal/lpProduct';

interface ProductContentV2Props {
  readonly productType?: readonly AggsOption[];
  readonly benefit?: readonly AggsOption[];
  readonly selectedCodes: readonly string[];
  readonly onChange: (groupType: LpProductGroupType, item: AggsOption) => void;
  readonly hideFilterOptionCounts?: boolean;
}

function ProductContentV2({
  productType,
  benefit,
  selectedCodes,
  onChange,
  hideFilterOptionCounts,
}: ProductContentV2Props): React.JSX.Element {
  return (
    <Box className="coner-benefit type-group">
      <FltBenefitBox
        className="flt-benefit-box"
        title="상품 유형"
        items={(productType ?? []).map(item => (
          <FltChkItem
            key={item.code}
            value={item.code}
            checked={selectedCodes.includes(item.code)}
            name={item.name}
            cnt={hideFilterOptionCounts ? undefined : item.count}
            onChange={() => onChange('productType', item)}
          />
        ))}
      />
      <FltBenefitBox
        className="flt-benefit-box"
        title="혜택"
        items={(benefit ?? []).map(item => (
          <FltChkItem
            key={item.code}
            value={item.code}
            checked={selectedCodes.includes(item.code)}
            name={item.name}
            cnt={hideFilterOptionCounts ? undefined : item.count}
            onChange={() => onChange('benefit', item)}
          />
        ))}
      />
    </Box>
  );
}

export default ProductContentV2;
